/* eslint-disable no-loop-func */
import { Box, Checkbox, Container, Grid, Stack, TextField } from '@mui/material';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { toPng } from 'html-to-image';

import { ButtonUI } from '../../component/CustomerMUI';
import classNames from 'classnames/bind';
import styles from './Photo.module.scss';
import { numberFormatText } from '../../utils/helper';
const cx = classNames.bind(styles);

const EditorImages = () => {
  const domEl = useRef(null);
  const prevScrollY = useRef();
  const [dataBase64, setDataBase64] = useState('');
  const [textSimExcel, setTextSimExcel] = useState([]);
  const [textPriceSimExcel, setTextPriceSimExcel] = useState([]);
  const [isTableEdit, setIsTableEdit] = useState(false);
  const [arrAllSimExcel, setArrAllSimExcel] = useState({
    row: { num: 3, title_1: 'SỐ ĐIỆN THOẠI', title_2: 'GIÁ', bgr: '#ef0000', color: '#ffd536', size: 45 },
    titleHeader: '',
    colorTextSim: '#ef0000',
    fontSizeTextSim: 55,
    colorTextPrice: '#000000',
    fontSizeTextPrice: 40,
    brgTable: '#fffcae',
    tablesim: [],
  });
  useEffect(() => {
    onHandleArraySim();
  }, []);

  const onButtonClick = useCallback(() => {
    if (domEl.current === null) {
      return;
    }

    toPng(domEl.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'my-image-name.png';
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  }, [domEl]);

  const onHandleArraySim = useCallback(() => {
    if (domEl.current === null) {
      return;
    }

    toPng(domEl.current, { cacheBust: true })
      .then((dataUrl) => {
        setDataBase64(dataUrl);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dataBase64]);

  const handleChangeSimExcel = (e, i) => {
    if (i === 1) {
      const text = e.target.value.split('\n');
      setTextSimExcel([...text]);
      let arrAllSim = [];
      text?.map((row, i) => {
        arrAllSim.push({ sim: row, price: textPriceSimExcel[i] });
      });
      const arrSim = { ...arrAllSimExcel, tablesim: arrAllSim };
      setArrAllSimExcel(arrSim);
      onHandleArraySim();
    }
    if (i === 2) {
      const text = e.target.value.split('\n');
      setTextPriceSimExcel(text);
      let arrAllSim = [];
      textSimExcel?.map((row, i) => {
        arrAllSim.push({ sim: row, price: text[i] });
      });
      const arrSim = { ...arrAllSimExcel, tablesim: arrAllSim };
      setArrAllSimExcel(arrSim);
      onHandleArraySim();
    }
  };
  const data = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

  const renderDivs = () => {
    const divs = [];

    for (let i = 0; i < data.length; i += 8) {
      const divData = data.slice(i, i + 8);

      const div = (
        <>
          <Grid container item xs={12} ref={domEl}>
            {divData.map((item, index) => (
              <>
                <Grid item key={index} xs={3} className={cx('domEl')} textAlign="center">
                  <Grid item xs={12}>
                    <span key={item}>{item}</span>
                  </Grid>
                </Grid>
              </>
            ))}
          </Grid>
          <br />
        </>
      );

      divs.push(div);
    }

    return divs;
  };

  return (
    <>
      <div style={{ height: '95vh' }}>
        <Container
          ref={prevScrollY}
          maxWidth="sm"
          sx={{
            pb: '55px',
            mt: '55px',
          }}
        >
          <Stack
            direction="column"
            spacing={1}
            sx={{ p: 2, border: '1px solid red', borderBottom: '5px solid red', borderRadius: 2 }}
          >
            <Stack direction="row" spacing={0.5} sx={{ mb: 0.5 }} justifyContent="center">
              <h2>TẠO ẢNH SIM THEO BẢNG</h2>
            </Stack>

            <Stack direction="row" spacing={0.5} sx={{ mb: 0.5 }} justifyContent="flex-end">
              <ButtonUI color="warning" onClick={() => setIsTableEdit(!isTableEdit)}>
                Chỉnh sửa bảng
              </ButtonUI>
              <ButtonUI color="error" onClick={onButtonClick}>
                Download
              </ButtonUI>
            </Stack>
            {dataBase64 && <img src={dataBase64} alt="Red dot" width={'100%'} />}
            {isTableEdit && (
              <Box>
                <Stack direction="row" spacing={0.5} sx={{ mb: 0.5, mt: 1 }} alignItems="center">
                  <label>
                    <b>Cột Sim</b>
                  </label>
                  <TextField
                    sx={{ border: '1px solid #fff', borderRadius: '5px', background: '#fff' }}
                    placeholder={`Nhập cột sim...`}
                    value={arrAllSimExcel?.row?.num}
                    size="small"
                    type="number"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        row: { ...arrAllSimExcel.row, num: parseInt(e.target.value) },
                      });
                      onHandleArraySim();
                    }}
                  />
                </Stack>

                <Stack direction="row" spacing={0.5} sx={{ mb: 0.5, mt: 1 }} alignItems="center">
                  <label>
                    <b>Tiêu đề</b>
                  </label>
                  <TextField
                    sx={{ border: '1px solid #fff', borderRadius: '5px', background: '#fff' }}
                    placeholder={`Nhập tiêu đề sim...`}
                    value={arrAllSimExcel?.titleHeader}
                    size="small"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        titleHeader: e.target.value,
                      });
                      onHandleArraySim();
                    }}
                  />
                </Stack>

                <Stack direction="row" spacing={0.5} sx={{ mb: 0.5, mt: 1 }} alignItems="center">
                  <label>
                    <b>Tiêu đề cột 1</b>
                  </label>
                  <TextField
                    sx={{ border: '1px solid #fff', borderRadius: '5px', background: '#fff' }}
                    placeholder={`Nhập tiêu đề cột 1...`}
                    value={arrAllSimExcel?.row?.title_1}
                    size="small"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        row: { ...arrAllSimExcel.row, title_1: e.target.value },
                      });
                      onHandleArraySim();
                    }}
                  />
                </Stack>

                <Stack direction="row" spacing={0.5} sx={{ mb: 0.5, mt: 1 }} alignItems="center">
                  <label>
                    <b>Tiêu đề cột 2</b>
                  </label>
                  <TextField
                    sx={{ border: '1px solid #fff', borderRadius: '5px', background: '#fff' }}
                    placeholder={`Nhập tiêu đề cột 2...`}
                    value={arrAllSimExcel?.row?.title_2}
                    size="small"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        row: { ...arrAllSimExcel.row, title_2: e.target.value },
                      });
                      onHandleArraySim();
                    }}
                  />
                </Stack>
                <Stack direction="row" spacing={0.5} sx={{ mb: 0.5, mt: 1 }} alignItems="center">
                  <Checkbox
                    color="success"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        row: { ...arrAllSimExcel.row, title_2: e.target.checked ? '' : 'GIÁ' },
                      });
                      onHandleArraySim();
                    }}
                  />
                  <label>
                    <b>ẨN CỘT GIÁ </b>
                  </label>
                </Stack>
                <Stack direction="row" spacing={0.5} sx={{ mb: 0.5, mt: 1 }} alignItems="center">
                  <label>
                    <b>Size Tiêu Đề</b>
                  </label>
                  <TextField
                    sx={{ border: '1px solid #fff', borderRadius: '5px', background: '#fff' }}
                    placeholder={`Nhập kích thước chữ...`}
                    value={arrAllSimExcel?.row?.size}
                    size="small"
                    type="number"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        row: { ...arrAllSimExcel.row, size: parseInt(e.target.value) },
                      });
                      onHandleArraySim();
                    }}
                  />
                </Stack>
                <Stack direction="row" spacing={2} sx={{ mb: 0.5, mt: 1 }} alignItems="center">
                  <label>
                    <b>Màu khung</b>
                  </label>
                  <input
                    defaultValue={arrAllSimExcel?.row?.bgr}
                    type="color"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        row: { ...arrAllSimExcel.row, bgr: e.target.value },
                      });
                      onHandleArraySim();
                    }}
                  />
                  <label>
                    <b>Màu chữ</b>
                  </label>
                  <input
                    defaultValue={arrAllSimExcel?.row?.color}
                    type="color"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        row: { ...arrAllSimExcel.row, color: e.target.value },
                      });
                      onHandleArraySim();
                    }}
                  />
                </Stack>

                <Stack direction="row" spacing={2} sx={{ mb: 0.5, mt: 1 }} alignItems="center">
                  <label>
                    <b>Màu chữ cột sim</b>
                  </label>
                  <input
                    defaultValue={arrAllSimExcel?.colorTextSim}
                    type="color"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        colorTextSim: e.target.value,
                      });
                      onHandleArraySim();
                    }}
                  />
                  <label>
                    <b>Size sim</b>
                  </label>
                  <TextField
                    sx={{ border: '1px solid #fff', borderRadius: '5px', background: '#fff' }}
                    placeholder={`Nhập kích thước chữ...`}
                    value={arrAllSimExcel?.fontSizeTextSim}
                    size="small"
                    type="number"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        fontSizeTextSim: parseInt(e.target.value),
                      });
                      onHandleArraySim();
                    }}
                  />
                </Stack>

                <Stack direction="row" spacing={2} sx={{ mb: 0.5, mt: 1 }} alignItems="center">
                  <label>
                    <b>Màu chữ cột giá</b>
                  </label>
                  <input
                    defaultValue={arrAllSimExcel?.colorTextPrice}
                    type="color"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        colorTextPrice: e.target.value,
                      });
                      onHandleArraySim();
                    }}
                  />
                  <label>
                    <b>Size giá</b>
                  </label>
                  <TextField
                    sx={{ border: '1px solid #fff', borderRadius: '5px', background: '#fff' }}
                    placeholder={`Nhập kích thước chữ...`}
                    value={arrAllSimExcel?.fontSizeTextPrice}
                    size="small"
                    type="number"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        fontSizeTextPrice: parseInt(e.target.value),
                      });
                      onHandleArraySim();
                    }}
                  />
                </Stack>

                <Stack direction="row" spacing={0.5} sx={{ mb: 0.5, mt: 1 }} alignItems="center">
                  <label>
                    <b>Màu nền khung</b>
                  </label>
                  <input
                    defaultValue={arrAllSimExcel?.brgTable}
                    type="color"
                    onChange={(e) => {
                      setArrAllSimExcel({
                        ...arrAllSimExcel,
                        brgTable: e.target.value,
                      });
                      onHandleArraySim();
                    }}
                  />
                </Stack>
              </Box>
            )}
            <b>
              <b>Nhập sim và giá lưu ý xuống dòng khi nhập xong 1 sim</b>
            </b>
            <Stack direction="row" sx={{ m: 2 }}>
              <TextField
                sx={{ border: '1px solid #fff', borderRadius: '5px', background: '#fff' }}
                multiline
                placeholder={`Nhập sim...`}
                fullWidth
                size="small"
                onChange={(e) => handleChangeSimExcel(e, 1)}
              />
              <TextField
                sx={{ border: '1px solid #fff', borderRadius: '5px', background: '#fff' }}
                multiline
                placeholder={`Nhập giá...`}
                fullWidth
                size="small"
                onChange={(e) => handleChangeSimExcel(e, 2)}
              />
            </Stack>
          </Stack>

          <div className={cx('dis-none-1')}>{renderDivs()}</div>
        </Container>
      </div>
    </>
  );
};

export default EditorImages;
